import React from "react";
import { siteConfig } from '../constant/siteConfig';
import { useLanguage } from '../i18n/LanguageContext';

const Footer = () => {
    const { t } = useLanguage();

    return (
        <footer className="text-white py-3  px-4" style={{ backgroundColor: siteConfig.brandColors.primary }}>
            <div className=" mx-auto flex flex-col md:flex-row items-center justify-between text-center md:text-left">
                

                {/* Links */}
                <div className="mt-4 md:mt-0 flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6">
                    <span className="text-sm font-semibold">{siteConfig.footer.name}</span>
                    <a
                        href={siteConfig.footer.termsOfServiceUrl}
                        className="hover:text-gray-300 text-sm transition"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {t('footer.terms')}
                    </a>
                    <a
                        href={siteConfig.footer.privacyPolicyUrl}
                        className="hover:text-gray-300 text-sm transition"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {t('footer.privacy')}
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
